import * as React from 'react';
import { tokens } from 'src/design-system';

const Asterisk = ({
    style,
    ...props
}: {
    style?: React.CSSProperties,
    [key: string]: any;
}) => {
    return <span {...props} style={{
        color: tokens.colors.error,
        marginLeft: '3px',
        ...style,
    }}>*</span>;
};

export default Asterisk;
